module.exports = __webpack_public_path__ + "static/media/logo2.7a345926.png";